<template>
<div>
  <span>{{ msg || 'No props passed yet' }}</span>
  {{colIdx+'-'+value.key}}
</div>
</template>

<script>
export default {
  name: "UnitSample",
  props: {
    msg: String,
    value:Object,
    colIdx:Number,
  }

}
</script>

<style scoped>

</style>